var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "VD",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Available-rides-details",
    transform: "translate(-22.000000, -406.000000)",
    stroke: "#FF5F00"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico_calendar_orange",
    transform: "translate(20.000000, 404.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(3.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-1",
    strokeWidth: 2,
    points: "0 19 18 19 18 4 0 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.0003,9.0001 L17.9997,9.0001",
    id: "Stroke-3",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.9997,2.0001 L1.9997,0.0001",
    id: "Stroke-4",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9997,2.0001 L15.9997,0.0001",
    id: "Stroke-5",
    strokeWidth: 2
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCalendar);
export default __webpack_public_path__ + "static/media/ico_calendar.d6592625961961d7f05fdc4bc7101a83.svg";
export { ForwardRef as ReactComponent };